
import Vue from "vue";
import $ from "jquery";
import moment from "moment";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import { JobVacancyModel } from "@/models/job.model";
import Job from "./company/Job.vue";
import About from "./company/About.vue";
import Contact from "./company/Contact.vue";
import { PaginationState } from "@/store/types";
import { SCHOOL_PARTNERSHIP } from "@/constants/enum.constant";
import { AxiosResponse } from "axios";

@Component({
  filters,
  components: {
    Job,
    About,
    Contact,
  },
})
export default class CompanyDetail extends Vue {
  /* VUEX */

  // ACTIONS
  @Action("actionSelectEmployerById", { namespace: "employer" })
  private actionSelectEmployerById: any;
  @Action("actionSelectEmployerVacancy", { namespace: "employer" })
  private actionSelectEmployerVacancy: any;

  // STATE
  @State("locale")
  public locale: string;
  @State("school", {namespace: "academy"})
  private school: any;
  @State("employer", { namespace: "employer" })
  private employer: any;
  @State("array_vacancy", { namespace: "employer" })
  private array_vacancy: Array<JobVacancyModel>;
  @State("pagination_vacancy", { namespace: "employer" })
  private pagination_vacancy: PaginationState;

  /* INITIALIZATION */
  private onLoad: boolean = false;
  private activePage: number = 1;
  private isPartnership: boolean = false;

  private breadcumbs:any[] = [
    {
      text: "company",
      href: "company"
    },
    {
      text: "",
      href: "#"
    }
  ]

  /* LIFECYCLE */

  private created() {
    this.actionSelectEmployerById({
      params: {
        id: this.$route.params.id
      },
      success: (res: AxiosResponse) => {
        this.isPartnership = res.data.partnership.latest_history.status === SCHOOL_PARTNERSHIP.ACTIVE;
        this.actionSelectEmployerVacancy();
      }
    });

    window.onscroll = () => {
      let scrollElem = (document.scrollingElement as HTMLElement)
      let canLoad = scrollElem.scrollTop + window.innerHeight >= scrollElem.scrollHeight - 10
      if (canLoad && !this.onLoad) {
        if (this.pagination_vacancy.url && this.school.id) {
          this.activePage++;
          this.clickPage(this.activePage, this.pagination_vacancy.url);
        }
      }
    }
  }

  /* METHODS */
  private clickPage(page: number, url: string) {
    this.onLoad = true;
    if (url) {
      this.actionSelectEmployerVacancy({
        params: {
          url: url,
          school_id: this.school.id,
          page: page
        },
        success: () => {
          this.onLoad = false;
        },
      });
    }
  }

  private isCheckStatus(employer: any) {
    // CHECK COMPANY VERIFIED (PENDING : 1, VERIFIED: 2, UNVERIFIED: 3)
    return employer.verification_status == 2;
  }

  private activateTab(label: string) {
    // Disable all
    for (const key in this.$data) {
      if (key) {
        this.$data[key] = false;
      }
    }

    // Enable selected
    this.$data[label] = true;
  }

  toDate(date: string) {
    return moment(date);
  }

  private limitText(text: string, limit = 200, warper = "...") {
    if (limit > 0) {
      let newText = String(
        $("<div>")
          .html(text)
          .text()
      );
      if (newText.length > limit) {
        return (newText = newText.substring(0, limit) + warper);
      }
      return newText;
    }
    return text;
  }
}
